import React from "react";
import { Typography, Card, CardContent, CardActions, Button, Box, Avatar, IconButton } from "@mui/material";
import ThumbUpIcon from "@mui/icons-material/ThumbUp";
import ThumbDownIcon from "@mui/icons-material/ThumbDown";
import CommentIcon from '@mui/icons-material/Comment';
import ShareIcon from '@mui/icons-material/Share';
import moment from "moment";
import { SCAMALERT_FILES_URL } from "src/api_endpoints/API_URL";
import ClearIcon from '@mui/icons-material/Clear';
import { useNavigate } from "react-router-dom";

const ScamAlertCommonCard = ({ scam, onReaction, isViewMyReports, handleOpenCommentsModal, onOpenModal, setShowConfirmationModal, setDeleteScamId, redirectionLinks, fromSingleScamPost = false, isLoggedIn = true }) => {
  // console.log(scam)
  const navigate = useNavigate()

  return (
    <Card sx={{ backgroundColor: "#ffffff", borderRadius: 2, marginBottom: "1rem" }}>
      {!isViewMyReports && (
        <CardContent sx={{ paddingBottom: "0" }}>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <Avatar sx={{ bgcolor: "#1976d2" }} src={scam.user_avatar || undefined}>
                {!scam.user_avatar && scam.first_name && scam.first_name[0]}
              </Avatar>
              <Typography variant="body2" sx={{ color: "#616161" }}>
                {scam.first_name + ' ' + scam.last_name} ({scam.expert_id})
              </Typography>
            </Box>
            {/* <IconButton>
              <Typography variant="body2" sx={{ color: "#616161" }}>{scam.alert_count}</Typography>
              <FlagIcon color="error" />
            </IconButton> */}
          </Box>
        </CardContent>
      )}

      {/* Card Content */}
      <CardContent sx={{ paddingBottom: "0"}}
        onClick={() => navigate(isLoggedIn
          ? `/client-expert/report-a-scam/${scam.first_name}_${scam.scam_code}_scam_${scam.scamPK}?my_reports=${isViewMyReports}`
          : `/report-a-scam/${scam.first_name}_${scam.scam_code}_scam_${scam.scamPK}?my_reports=${isViewMyReports}`)}
      ><Box
  className="flex flex-col-reverse sm:flex-row justify-between items-start sm:items-center"
>

          <Typography
            variant="body2"
            sx={{
              color: "#616161",
              fontSize: "0.9rem",
              cursor: 'pointer',
              minWidth:'max-conent',
              mb: { xs: 0.5, sm: 0 } 
            }}
          >
            Scam ID: {scam.scam_code}
          </Typography>
          <Box
            className="flex items-center gap-2"
            sx={{
              display: { xs: 'flex', sm: 'flex', md: 'unset' },
              justifyContent: { xs: 'space-between', sm: 'end', md: 'unset' },
              width: { xs: '100%', sm: '100%', md: 'auto' }
            }}
          >
            <Typography
              variant="body2"
              sx={{ color: "#616161", fontSize: "0.9rem", display: { xs: 'block', sm: 'inline' } }}
            >
              {moment(scam.date_created).format("DD MMM YYYY")}
            </Typography>
            <Box>
              {isViewMyReports && (
                <IconButton sx={{padding:'.2rem'  }} onClick={(e) => {
                  e.stopPropagation();
                  setShowConfirmationModal(true);
                  setDeleteScamId(scam.scamPK);
                }}>
                  <ClearIcon color="error" />
                </IconButton>
              )}
              <IconButton
                onClick={async (e) => {
                  e.stopPropagation();
                  const scamURL = `${window.location.origin}/report-a-scam/${scam.first_name}_${scam.scam_code}_scam_${scam.scamPK}`;
                  if (navigator.share) {
                    try {
                      await navigator.share({
                        title: 'Scam Alert',
                        text: scam.description || 'Check out this scam report!',
                        url: scamURL,
                      });
                    } catch (err) {
                      console.error("Share failed:", err);
                    }
                  } else {
                    navigator.clipboard.writeText(scamURL);
                  }
                }}
                sx={{padding:'.2rem'  }}
              >
                <ShareIcon sx={{ color: "#6d4cb1" }} />
              </IconButton>
            </Box>
          </Box>
        </Box>

        <Typography variant="body1" sx={{ color: "#424242", marginBottom: '1rem', whiteSpace: "pre-wrap", wordBreak: "break-word", }}>
          {scam.description}
        </Typography>
      </CardContent>

      <Box sx={{
        margin: '1rem',
        display: 'grid',
        gridTemplateColumns: 'repeat(2, 1fr)',
        gap: '1px',
        gridAutoRows: '120px',
        height: `${Math.min(Math.ceil(scam?.attachments?.length / 2), 2) * 120}px`,
        overflow: 'hidden',
      }}>
        {scam?.attachments?.slice(0, 4).map((attachment, index) => (
          <Button
            key={index}
            variant="contained"
            sx={{
              lineHeight: 1,
              minWidth: '100%',
              textTransform: 'none',
              background: 'none',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              padding: 0,
              height: '120px',
              overflow: 'hidden',
              position: 'relative',
            }}
            onClick={() => onOpenModal(scam.attachments)}
          >
            <img
              src={`${SCAMALERT_FILES_URL}/${attachment}`}
              alt={`Attachment ${index + 1}`}
              style={{width: '100%',height: '100%',objectFit: 'cover'}}
            />
            {index === 3 && scam.attachments.length > 4 && (
              <Typography
                onClick={() => onOpenModal(scam.attachments)}
                variant="body2"
                sx={{
                  position: 'absolute',
                  bottom: '2.6rem',
                  right: '40%',
                  backgroundColor: 'rgba(0, 0, 0, 0.6)',
                  color: 'white',
                  padding: '2px 8px',
                  borderRadius: '8px',
                  cursor: 'pointer',
                  fontSize: '1.6rem',
                }}
              >
                +{scam.attachments.length - 4}
              </Typography>
            )}
          </Button>
        ))}
      </Box>
      <CardActions sx={{ display: "flex", justifyContent: "space-between", padding: ".5rem 1rem" }}>
        <Button
          startIcon={<ThumbUpIcon sx={{ color: scam.isLoggedInUserLiked ? "#0080ff" : "#639acf99" }} />}
          sx={{ textTransform: "none", color: "#639acf99" }}
          onClick={() => onReaction(scam.scamPK, scam.reaction_type === 1 ? 'null' : 1)}
          // disabled={scam.isLoggedInUserLiked}
          disabled={Boolean(scam.isLoggedInUserLiked)}
        >
          {scam?.total_likes}
        </Button>
        {
          !fromSingleScamPost &&
          <Button
            startIcon={<CommentIcon sx={{ color: "#0080ffc2" }} />}
            sx={{ textTransform: "none", color: "gray" }}
            onClick={() => handleOpenCommentsModal(scam)}
          >
            {scam?.count_comment > 0 ? `Comment (${scam.count_comment})` : 'Comment'}
          </Button>
        }

        <Button
          startIcon={<ThumbDownIcon sx={{ color: scam.isLoggedInUserDisliked ? "red" : "#fa737399" }} />}
          sx={{ textTransform: 'none', color: scam.isLoggedInUserDisliked ? "red" : "#fa737399" }}
          onClick={() => onReaction(scam.scamPK, scam.reaction_type === 2 ? 'null' : 2)}
          disabled={!!scam.isLoggedInUserDisliked}
        >
          {scam?.total_dislikes}
        </Button>
      </CardActions>
    </Card>
  );
};

export default React.memo(ScamAlertCommonCard);
